/**
 * Copy of the material category icons that are rendered in Polylino's category select, any change here must be mirrored in **`apps/polylino/src/foundation/constants/material-icons.ts`**,
 * which is what actually renders them.
 */
export const CATEGORY_SELECT_ICONS: string[] = [
  'abacus',
  'ballot-check',
  'book',
  'book-font',
  'book-open-cover',
  'book-open-reader',
  'books',
  'box-archive',
  'bullseye-arrow',
  'calculator',
  'calendar-days',
  'chalkboard-user',
  'chart-simple',
  'circle-play',
  'clipboard',
  'clone',
  'comments',
  'dice',
  'earth-americas',
  'feather-pointed',
  'file',
  'flask',
  'folder',
  'folder-open',
  'font',
  'head-side-speak',
  'headphones',
  'house-laptop',
  'images',
  'landmark',
  'language',
  'leaf',
  'link',
  'list-check',
  'masks-theater',
  'microphone-lines',
  'microscope',
  'music',
  'note-sticky',
  'notebook',
  'palette',
  'pen-fancy',
  'pencil-line',
  'people-group',
  'people-roof',
  'presentation-screen',
  'print',
  'puzzle-piece',
  'quote-left',
  'rectangle-history',
  'ruler-combined',
  'scissors',
  'shapes',
  'signature',
  'spell-check',
  'square-question',
  'star',
  'timeline',
  'wand-magic-sparkles',
  'waveform-lines',
];

const ICON_STYLE = 'fa-light';

export const categorySelectIconClass = (name: string): string => `${ICON_STYLE} fa-${name}`;
